import { createFileRoute } from "@tanstack/react-router";
import PageContent from "@/components/PageContent";
import TitleBar from "@/components/layout/TitleBar";

export const Route = createFileRoute('/about')({
  component: About,
})

const board = [
  {
    office: "President",
    officers: ["Kevin Roberts"],
  },
  {
    office: "Secretary/Treasurer",
    officers: ["Chris Koop"],
  },
  {
    office: "Assistant Secretary",
    officers: ["Marge Washburn"],
  },
  {
    office: "Directors",
    officers: [
      "Mike Brown",
      "Alan Conkle",
      "Terry Eckert",
      "Walt Hazelton",
      "Charlie Miller",
      "Stephen Wilde",
    ],
  },
  {
    office: "Office Staff",
    officers: [
      "Sherry Wilde, Manager",
      "Shannon LaForce, Operations Manager",
      "Brian Feagan, Operations Coordinator",
    ],
  },
];

function About() {
  return (
    <>
      <TitleBar />
      <PageContent>
        <section>
          <h1>About EVTCC</h1>
          <p>
            The EVT Certification Commission, Inc. is a nonprofit corporation
            dedicated to improving the quality of emergency vehicle service
            and repair throughout the United States and Canada by means of a
            certification program that will provide technicians recognition
            for the education, training, and experience they have in the
            service and repair of emergency vehicles.
          </p>
        </section>
        <section>
          <h2>Board of Directors</h2>
          {board.map((position) => (
            <div className="my-2 mb-4" key={position.office}>
              <h3 className="ml-2">
                {position.office}
              </h3>
              <div className="ml-4">
                {position.officers.map((of) => (
                  <p key={of}>
                    {of}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </section>
      </PageContent>
    </>
  );
}
